'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

angular.module('services.search', [])

.factory('searchService', ['$http', '$q', function ($http, $q) {

    var service = {};

    // ***** HttpGet

    // Business Process
    service.searchBusinessTasks = function (searchTerm) {
        return $http.get(environment.apiUrl + '/ID/API/BusinessTask/Search/Active?searchTerm=' + searchTerm)
                    .then(function (response) {
                        return response.data;
                    });
    }

    // Systems
    service.searchSystems = function (searchTerm, config) {
        var defaultConfig = _.assign({}, config);

        return $http.get(environment.apiUrl + '/ID/API/System/Search/Active?searchTerm=' + searchTerm, defaultConfig)
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.basicSearchSystems = function (searchTerm) {
        return $http.get(environment.apiUrl + '/ID/API/System/Search/Basic/Active?searchTerm=' + searchTerm)
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.searchUnstructuredSystems = function (searchTerm) {
        return $http.get(environment.apiUrl + '/ID/API/System/Search/Unstructured/Active?searchTerm=' + searchTerm)
                    .then(function (response) {
                        return response.data;
                    });
    }

    // Business Unit head employee available
    service.searchActiveAndAvailableEmployees = function (searchTerm) {
        return $http.get(environment.apiUrl + '/ID/BusinessUnit/API/Employee?searchTerm=' + searchTerm)
                    .then(function (response) {
                        return response.data;
                    });
    }

    // Employees
    service.searchActiveEmployees = function (searchTerm, config) {
        var defaultConfig = _.assign({}, config);

        return $http.get(environment.apiUrl + '/ID/API/Employee/Search/Active?searchTerm=' + searchTerm, defaultConfig)
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.searchEmployees = function (searchTerm) {
        return $http.get(environment.apiUrl + '/ID/API/Employee/Search?searchTerm=' + searchTerm)
                    .then(function (response) {
                        return response.data;
                    });
    }

    // Supervisors
    service.searchSupervisors = function (searchTerm) {
        return $http.get(environment.apiUrl + '/ID/API/Supervisor/Search/Active?searchTerm=' + searchTerm)
                    .then(function (response) {
                        return response.data;
                    });
    }

    return service;
}]);
